(function($){
    $(function(){

        $(".accordion").click(function(){
            $(this).toggleClass("active");
            $(this).next(".panel").slideToggle("slow");
            });

        $('a').each(function() {
            var a = new RegExp('/' + window.location.host + '/');
            if (!/stauningwhisky.com/i.test(this.href)) {
               $(this).attr("target","_blank");
            }
        });
        function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
              sURLVariables = sPageURL.split("&"),
              sParameterName,
              i;
      
            for (i = 0; i < sURLVariables.length; i++) {
              sParameterName = sURLVariables[i].split("=");
      
              if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                  ? true
                  : decodeURIComponent(sParameterName[1]);
              }
            }
            return false;
        }
          


        window.addEventListener("klaviyoForms", function(e) { 
            if (e.detail.type == 'submit' && e.detail.formId == "SurdMs") {
                $('.form-submission-notification').show();
                setTimeout(function(){
                    location.reload();
                },6000);
            }
        });
        // Distillery Sign Forms
        if($('#distillery-signup-page').length > 0 ){
            $('.requirement-btn').on('change',function(){
                if($(this).is(":checked")){
                    $(this).parents('form').find('button').prop('disabled', false);
                    $(this).val(true);
                } else {
                    $(this).parents('form').find('button').prop('disabled', true);
                    $(this).val(false);
                }
            })
            $('.newsletter-flyout-inner form').on('submit',function(e){
                console.log('form submitted');
                //https://stauningwhisky.com/pages/distillery-news?submit=1
            })
            $('.terms-modal-trigger-english').on('click',function(e){
                e.preventDefault();
                $('.terms-modal-english').fadeIn();
            })
            $('.terms-modal-trigger-danish').on('click',function(e){
                e.preventDefault();
                $('.terms-modal-danish').fadeIn();
            })
            $('.terms-modal-close').on('click',function(e){
                e.preventDefault();
                $('.terms-modal').fadeOut();
            })
        }


        $('.vimemovid').on('click',function(e){
            let src = $(this).data('videosrc');
            console.log(src);
            BigPicture({
                el: e.target,
                vidSrc: src,
            })
        })
        // if($('.book-tour-button').length > 0){
        //     $('.book-tour-button').on('click', function(){
        //         $('.book-tour-modal').addClass('modal-display');
        //         $('.book-tour-modal-bg').fadeIn();
        //     })
        //     $('.book-tour-modal-bg, .book-tour-modal-close').on('click', function(){
        //         $('.book-tour-modal').removeClass('modal-display');
        //         $('.book-tour-modal-bg').fadeOut();
        //     })
        // }

        if($('.shop-button').length > 0){
            $('.shop-button').on('click', function(){
                $('.shop-whisky-modal').addClass('modal-display');
                $('.shop-whisky-modal-bg').fadeIn();
            })
            $('.shop-whisky-modal-bg, .shop-modal-close').on('click', function(){
                $('.shop-whisky-modal').removeClass('modal-display');
                $('.shop-whisky-modal-bg').fadeOut();
            })
        }


        if($('.recipe-gallery-content').length > 0) {
            $(window).on('resize load orientationchange', function(){
                var recipeNameHeight = 0;
                $('.recipe-gallery-content').each(function(){
                    var thisHeight = $(this).outerHeight();
                    if(thisHeight > recipeNameHeight){
                        recipeNameHeight = thisHeight;
                    }
                });
                $('.recipe-gallery-content').css('min-height',recipeNameHeight);
            });
        };



        if($('#newsletter-flyout').length > 0) {
            var newsletterCookie = Cookies.get("newsletter-visible");
            if(newsletterCookie === undefined && document.location.pathname.indexOf("/distillery-news") < 0) {
                setTimeout(function(){
                    $('#newsletter-flyout').fadeIn();
                },5000)
            }

            $('#newsletter-close-btn').on('click',function(){
                Cookies.set("newsletter-visible", 'seen' , {expires: 7 });
                $('#newsletter-flyout').fadeOut();
            })

            $('.open-newsletter > a').on('click',function(e){
                e.preventDefault();
                $('#newsletter-flyout').fadeIn();
            })
        }

        function englishCheckoutLink() {
          if($('.cart-onorder-item').length > 0 ){
              var englishCheckout = 'https://caskliquidmarketing.com/cart/?add-to-cart=',
              singleProdCart = '',
              firstProdID = '',
              firstProdQty = '',
              index = 1;
              $('.cart-onorder-item').each(function(i){
                  var engID = $(this).data('english-id'),
                  deQty = $(this).find('.quantity').val();
                  if(engID !== 'undefined' && engID !== undefined && deQty !== 'undefined' && deQty !== undefined ){
                    if(index == 1) {
                        firstProdID = engID;
                        firstProdQty = deQty;
                        singleProdCart = firstProdID+'&quantity='+firstProdQty;
                    }
                    if(index > 1) {
                        if(index == 2) {
                            englishCheckout += firstProdID+":"+firstProdQty;
                        }
                        englishCheckout += ',';
                        englishCheckout += engID+":"+deQty;
                    }                        
                    index++;
                  } else {
                    $(this).addClass('not-available');
                  }
              });
              if(index == 2) {
                englishCheckout += singleProdCart;
              }
              $('#english-checkout').attr('href',englishCheckout);
          } else {
            //https://caskliquidmarketing.com/stauning-whisky/
            $('#english-checkout').attr('href','https://caskliquidmarketing.com/?s=stauning');
          }
        }

        function germanCheckoutLink() {
          if($('.cart-onorder-item').length > 0 ){
              var germanCheckout = 'https://www.whisky.de/shop/warenkorb/?&fnc=tobasket',
              index = 1;
              $('.cart-onorder-item').each(function(i){
                  var oxid = $(this).data('german-oxid'),
                  deQty = $(this).find('.quantity').val();
                  if(oxid !== 'undefined' && oxid !== undefined && deQty !== 'undefined' && deQty !== undefined ){
                      germanCheckout += '&aproducts[artikel'+index+'][aid]='+oxid+'&aproducts[artikel'+index+'][am]='+deQty;
                      index++;
                  } else {
                    $(this).addClass('not-available');
                  }
              });
              $('#german-checkout').attr('href',germanCheckout);
          } else {
            $('#german-checkout').attr('href','https://www.whisky.de/whisky/suchen.html?L=0&id=730&tx_solr%5Bq%5D=stauning');
          }
        }

        var langify = langify || {};
        langify.settings = {
          debug: true
        }





        var myLang = Cookies.get("ly-lang-selected");
        if( myLang === 'da') {
            if($('.cart-onorder-item').length > 0) {
                $('.cart-onorder-item').each(function(){
                    var stockCount = $(this).data('stock-count');
                    if(stockCount == 0){
                        var prod_id = $(this).attr('id')
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            dataType: 'json',
                            data: {
                                quantity: 0,
                                id: prod_id
                            },
                            success: function (data){
                                $.ajax({
                                    type: 'GET',
                                    dataType: 'jsonp',
                                    url: '/cart.json',
                                    success: function(cart){
                                        var item_count = cart['item_count'];
                                        var total_price = cart['total_price']/100;
                                        var total = '.cart-total-price';
                                        var cartCountSelector = '.gb-cart-count';
                                        Shopify.getCart(function(data) { 

                                            var cartItems = data;
                                            var giftAdded = false;
                                            $.each(cartItems.items, function (e) {
                                                if (cartItems.items[e].id == giftVariantID) {
                                                    giftAdded = true;
                                                }
                                            })
                                            if(giftAdded){
                                                var totalPrice = data.total_price - freeProdPrice;
                                                var totPrice = Shopify.formatMoney(totalPrice,'KR \{\{amount}}');
                                                console.log('giftAdded',totPrice);
                                            } else {
                                                var totPrice = Shopify.formatMoney(data.total_price,'KR \{\{amount}}');
                                                console.log('gift NOT Added',totPrice);
                                            }

                                        //   var totPrice = Shopify.formatMoney(data.total_price,'KR \{\{amount}}');
                                          bPrice = totPrice.split('.')[0],
                                          cPrice = totPrice.split('.')[1],
                                          totalFormatted = bPrice + "<sup>."+ cPrice + "</sup>";
                                          $(total).html(totalFormatted);
                                            var value = $(cartCountSelector).html() || '0';
                                            $(cartCountSelector).html(value.replace(/[0-9]+/,data.item_count)).removeClass('hidden-count');
                                            if(item_count == 0 ) {
                                              $('.cart-onorder-content').removeClass('bag-filled');
                                            } else {
                                                $('.gb-cart-count').text(item_count);
                                            }
                                            $('#'+prod_id).remove();
                                        });
                                    }
                                });
                            }
                        });
                    }
                })
            }

            var fullUrl = location.host + location.pathname;
            if (fullUrl.indexOf("com/da") == -1) {
                window.location.href = 'https://'+location.host + "/da" + location.pathname; 
            } 
            
            $('body').addClass('da-lang-selected');
            $('body').removeClass('de-lang-selected');
            $('body').removeClass('eng-lang-selected');
            $('.lang-switcher-display').html('Dansk');
            if($('input[value="Add to cart"]').length > 0) {
                $('input[value="Add to cart"]').each(function(){
                    if($(this).data('danish-text') != ''){
                        var newVal = $(this).data('danish-text');
                    } else {
                        var newVal = 'Læg i kurv';
                    }
                    $(this).val(newVal);
                })
            }
        } else if( myLang === 'de') {
            var fullUrl = location.host + location.pathname;
            if (fullUrl.indexOf("com/de") == -1) {
                window.location.href = 'https://'+location.host + "/de" + location.pathname; 
            } 
            $('body').addClass('de-lang-selected');
            $('body').removeClass('eng-lang-selected');
            $('body').removeClass('da-lang-selected');
            $('body').removeClass('us-lang-selected');
            $('.lang-switcher-display').html('Deutsch');
            if($('input[value="Add to cart"]').length > 0) {
                $('input[value="Add to cart"]').each(function(){
                    if($(this).data('german-text') !== undefined ){
                        var newVal = $(this).data('german-text');
                    } else {
                        var newVal = 'Kaufe jetzt';
                    }
                    $(this).val(newVal);
                })
            }
        } else {
            var dialect = Cookies.get("english-dialect");
            $('body').removeClass('da-lang-selected');
            $('body').removeClass('de-lang-selected');
            $('body').addClass('eng-lang-selected');
            if(dialect == 'uk'){
                $('.lang-switcher-display').html('English UK');
            } else if(dialect == 'usa'){
                $('.lang-switcher-display').html('English US');
            } else {
                $('.lang-switcher-display').html('Rest of the world');
            }
        }

        var myCookie = Cookies.get("gdpr-loc-age");
        if( myCookie === undefined) {
            if(Shopify.designMode != true && document.location.pathname.indexOf("/distillery-news") < 0 && document.location.pathname.indexOf("/terms-and-conditions") < 0){
                $('#concent-modal').fadeIn();
                $('body').addClass('gdpr-notice-open');
            }
        } else {
            $('body').addClass(myCookie);
            christmasPopup();
        }
        $('#age-ver').on('click',function () {
            if ($(this).is(':checked')) {
                setTimeout(function(){
                    $('.are-you-old-enough').slideUp();
                    $('.where-you-from').slideDown();
                },500)
            } 
        });

        function christmasPopup(){
            (function(w,d,s,l,r,a,m){
                  if(d.getElementById(r))return;
                  w[r]=w[r]||{};a=d.createElement(s),m=d.getElementsByTagName(s)[0];
                  a.async=1;a.src=l;a.id=r;m.parentNode.insertBefore(a,m);
              })(window,document,'script','https://cdn.scratcher.io/embed/12384.js','Scratcher_12384');
              Scratcher_12384.options = {
                  slug: 'julekalender-pop-up',
                  width: '100%',
                  height: 1100,
              };
        }
        if($('.change-to-usa').length > 0){
            $('.change-to-usa').on('click',function(){
                Cookies.set("english-dialect","usa");
                Cookies.set("gdpr-loc-age","us-gdpr-approved");
                $('body').addClass('us-gdpr-approved');
            })  
        }


        $('.cookie-btn').on('click',function(e){
            e.preventDefault();
            var btnID = $(this).attr('id');
            if(btnID == 'btn-uk') {
                Cookies.set("english-dialect","uk");
                Cookies.set("gdpr-loc-age","uk-gdpr-approved");
                $('body').addClass('uk-gdpr-approved');
                var pathName = location.pathname;
                if(pathName.indexOf("/de") == 0 ) {
                    pathName = pathName.replace('/de','');
                }
                if(pathName.indexOf("/da") == 0 ) {
                    pathName = pathName.replace('/da','');
                }
                window.location.href = 'https://'+location.host + pathName;  
            }
            if(btnID == 'btn-us') {
                Cookies.set("english-dialect","usa");
                Cookies.set("gdpr-loc-age","us-gdpr-approved");
                $('body').addClass('us-gdpr-approved');
                var pathName = location.pathname;
                if(pathName.indexOf("/da") == 0 ) {
                    pathName = pathName.replace('/da','');
                }
                if(pathName.indexOf("/de") == 0 ) {
                    pathName = pathName.replace('/de','');
                }
                window.location.href = 'https://'+location.host + pathName;  
            }
            if(btnID == 'btn-germany') {
                Cookies.set("ly-lang-selected","de");
                Cookies.set("gdpr-loc-age","ger-gdpr-approved");
                $('body').addClass('ger-gdpr-approved');
                var pathName = location.pathname;
                if (pathName.indexOf("/de") != 0) {
                    if(pathName.indexOf("/da") == 0 ) {
                        pathName = pathName.replace('/da','');
                    }
                    window.location.href = 'https://'+location.host + "/de" + pathName;
                }
            }
            if(btnID == 'btn-denmark') {
                Cookies.set("ly-lang-selected","da");
                Cookies.set("gdpr-loc-age","den-gdpr-approved", );
                $('body').addClass('den-gdpr-approved');
                var pathName = location.pathname;
                if (pathName.indexOf("/da") != 0) {
                    if(pathName.indexOf("/de") == 0 ) {
                        pathName = pathName.replace('/de','');
                    }
                  window.location.href = 'https://'+location.host + "/da" + pathName;  
                }
            }
            if(btnID == 'btn-row') {
                Cookies.set("english-dialect","row");
                Cookies.set("gdpr-loc-age","row-gdpr-approved");
                $('body').addClass('row-gdpr-approved');
                var pathName = location.pathname;
                if(pathName.indexOf("/de") == 0 ) {
                    pathName = pathName.replace('/de','');
                }
                if(pathName.indexOf("/da") == 0 ) {
                    pathName = pathName.replace('/da','');
                }
                window.location.href = 'https://'+location.host + pathName;  
            }
            $('#concent-modal').fadeOut();
            $('body').removeClass('gdpr-notice-open');
        })



/* CUSTOM LANG SWITCH */
$('.lang-switcher-display').on('click',function(){
    $('.language-switcher-list').slideToggle();
})

$('.custom-lang-btn').on('click',function(e){
    e.preventDefault();
    var btn = $(this);
    var btnText = btn.html();
    $('.lang-switcher-display').html(btnText);
    if(btn.hasClass('cust-lang-eng-uk')) {
        Cookies.set("ly-lang-selected","en");
        Cookies.set("english-dialect","uk");
        Cookies.set("gdpr-loc-age","uk-gdpr-approved");
        $('body').addClass('uk-gdpr-approved');
        var pathName = location.pathname;
        if(pathName.indexOf("/de") == 0 ) {
            pathName = pathName.replace('/de','');
        }
        if(pathName.indexOf("/da") == 0 ) {
            pathName = pathName.replace('/da','');
        }
        window.location.href = 'https://'+location.host + pathName;
    }
    if(btn.hasClass('cust-lang-eng-us')) {
        Cookies.set("ly-lang-selected","en");
        Cookies.set("english-dialect","usa");
        Cookies.set("gdpr-loc-age","us-gdpr-approved");
        $('body').addClass('us-gdpr-approved');
        var pathName = location.pathname;
        if(pathName.indexOf("/da") == 0 ) {
            pathName = pathName.replace('/da','');
        }
        if(pathName.indexOf("/de") == 0 ) {
            pathName = pathName.replace('/de','');
        }
        window.location.href = 'https://'+location.host + pathName;  
    }
    if(btn.hasClass('cust-lang-de')) {
        Cookies.set("ly-lang-selected","de");
        Cookies.set("gdpr-loc-age","ger-gdpr-approved");
        $('body').addClass('ger-gdpr-approved');
        var pathName = location.pathname;
        if (pathName.indexOf("/de") != 0) {
            if(pathName.indexOf("/da") == 0 ) {
                pathName = pathName.replace('/da','');
            }
            window.location.href = 'https://'+location.host + "/de" + pathName;
        }
    }
    if(btn.hasClass('cust-lang-da')) {
        Cookies.set("ly-lang-selected","da");
        Cookies.set("gdpr-loc-age","den-gdpr-approved");
        $('body').addClass('den-gdpr-approved');
        var pathName = location.pathname;
        if (pathName.indexOf("/da") != 0) {
            if(pathName.indexOf("/de") == 0 ) {
                pathName = pathName.replace('/de','');
            }
          window.location.href = 'https://'+location.host + "/da" + pathName;  
        }
    }
    if(btn.hasClass('cust-lang-row')) {
        Cookies.set("ly-lang-selected","en");
        Cookies.set("english-dialect","row");
        Cookies.set("gdpr-loc-age","row-gdpr-approved");
        $('body').addClass('row-gdpr-approved');
        var pathName = location.pathname;
        if(pathName.indexOf("/de") == 0 ) {
            pathName = pathName.replace('/de','');
        }
        if(pathName.indexOf("/da") == 0 ) {
            pathName = pathName.replace('/da','');
        }
        window.location.href = 'https://'+location.host + pathName;
    }
})

$('.switch-to-danish').on('click',function(e){
    e.preventDefault();
    Cookies.set("ly-lang-selected","da");
    Cookies.set("gdpr-loc-age","den-gdpr-approved");
    $('body').addClass('den-gdpr-approved');
    var pathName = location.pathname;
    if (pathName.indexOf("/da") != 0) {
        if(pathName.indexOf("/de") == 0 ) {
            pathName = pathName.replace('/de','');
        }
      window.location.href = 'https://'+location.host + "/da" + pathName;  
    }
}); 

if($('.location-changer-wrap').length > 0) {
    $('body').on('click','.location-changer-display',function(){
        $(this).siblings('.location-changer-list-wrap').slideToggle();
    });
    // Close .location-changer-list-wrap when clicking .location-changer-close or outside .location-changer-list-wrap
    $('body').on('click', function(e){
        // If click on close button
        if ($(e.target).hasClass('location-changer-close')) {
            $('.location-changer-list-wrap').slideUp();
        }
        // If click outside location-changer-list-wrap and not on the display button
        else if (
            $('.location-changer-list-wrap').is(':visible') &&
            !$(e.target).closest('.location-changer-list-wrap').length &&
            !$(e.target).closest('.location-changer-display').length
        ) {
            $('.location-changer-list-wrap').slideUp();
        }
    });

}










        $('.ly-languages-switcher-link').on('click',function(){
            var code = $(this).data('language-code');
            if(code == 'da'){
                Cookies.set("gdpr-loc-age","den-gdpr-approved");
            } else if (code == 'de') {
                Cookies.set("gdpr-loc-age","ger-gdpr-approved");
            } else {
                var english = Cookies.get("english-dialect");
                if( english === undefined) {
                    Cookies.set("english-dialect","row");
                    Cookies.set("gdpr-loc-age","row-gdpr-approved");
                } else if( english === 'usa') {
                    Cookies.set("gdpr-loc-age","us-gdpr-approved");
                } else if( english === 'uk'){
                    Cookies.set("gdpr-loc-age","uk-gdpr-approved");
                }
            }
        })

        $('.dialect-btn').on('click',function(e){
            e.preventDefault();
            var btnID = $(this).attr('id');
            if(btnID == 'uk-dialect-btn') {
                Cookies.set("english-dialect","uk");
                Cookies.set("gdpr-loc-age","uk-gdpr-approved");
            }
            if(btnID == 'usa-dialect-btn') {
                Cookies.set("english-dialect","usa");
                Cookies.set("gdpr-loc-age","us-gdpr-approved");
            }
            location.reload(true);
        });
        if($('.dialect-trigger').length > 0) {
            $('.dialect-trigger').on('click', function(){
                $('#dialect-select').toggleClass('active');
                $('.english-dialect-select .dialect-selection').toggle();
            })
            
        }
        

        setTimeout(function(){
            $('body').addClass('page-loaded');
        },2000);
            

        $(window).scroll(function() {
            var scrollDistance = $(window).scrollTop();

            // Show/hide menu on scroll
            //if (scrollDistance >= 850) {
            //      $('nav').fadeIn("fast");
            //} else {
            //      $('nav').fadeOut("fast");
            //}

            // Assign active class to nav links while scolling
            $('.page-section').not('.remove-eng, .remove-de').each(function(i) {
                if ($(this).position().top <= scrollDistance + 1) {
                    $('.fixed-tab-scroll-wrap a.active').removeClass('active');
                    $('.fixed-tab-scroll-wrap a').eq(i).addClass('active');
                }
            });
        }).scroll();


        $('a[href*=\\#]').not('[href="#"]').not('[href="#0"]').bind('click', function(e) {
            e.preventDefault(); // prevent hard jump, the default behavior
            var target = $(this).attr("href"); // Set the target as variable
            // perform animated scrolling by getting top-position of target-element and set it as scroll target
            $('html, body').stop().animate({
                scrollTop: $(target).offset().top
            }, 600, function() {
                location.hash = target; //attach the hash (#jumptarget) to the pageurl
            });

            return false;
        });


        // ANIMATION CHECK IF IN VIEW
        var $animation_elements = $('.anim-el');
        var $window = $(window);
        var $fadeOnScroll = $('.fade-on-scroll');
        function check_if_in_view() {
            var window_height = $window.height();
            var half_window = window_height / 2 // half window height

            var insetAmount = window_height / 5 // fifth of the screen
            var window_top_position = $window.scrollTop();
            var window_bottom_position = (window_top_position + window_height) - insetAmount;

            if(window_top_position > window_height) {
                $('body').addClass('fixed-top-nav');
                $('.fixed-tab-scroll-wrap.collection-menu').removeClass('collection-menu-slide-up');
            } else {
                var $collectionMenu = $('.fixed-tab-scroll-wrap.collection-menu');
                if ($collectionMenu.length && $(window).width() <= 767) {
                    $collectionMenu.addClass('collection-menu-slide-up');
                    $collectionMenu.one('animationend webkitAnimationEnd', function() {
                        if ($(window).scrollTop() <= window_height) {
                            $('body').removeClass('fixed-top-nav');
                        }
                        $collectionMenu.removeClass('collection-menu-slide-up');
                    });
                } else {
                    $('body').removeClass('fixed-top-nav');
                }
            }

            $.each($fadeOnScroll, function(){
                var $element = $(this);
                var element_top_position = $element.offset().top;
                var trigger_point = element_top_position - half_window;
                var trigger_endpoint = element_top_position + 100; 
                var scrolled = window_top_position - trigger_point;
                var toScroll = half_window - scrolled;
                var opacity = toScroll/half_window;
                if(opacity > 1 ) {
                    $element.css('opacity',1);
                } else if (opacity < 0){
                     $element.css('opacity',0);
                } else {
                    $element.css('opacity',opacity); 
                }
               

            });

            $.each($animation_elements, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                if (element_top_position <= window_bottom_position) {
                    $element.addClass('in-view');
                } else {
                    if(!$element.hasClass('anim-once')) {
                        $element.removeClass('in-view');
                    }
                    
                }
            });
        }
        $window.on('scroll orientationchange resize', check_if_in_view);
        $window.trigger('scroll');



      


        // Phone nav click function
        $('.menu-icon-wrap').click(function () {
            $("body").toggleClass("navShown");
            $(".nav-wrap").fadeIn()
        });

        $(".main-nav ul > li").find("ul").parent("li").addClass("show");
        $(".main-nav ul > li").find("ul").parent("li").addClass("has-sub-nav");
        $(".main-nav ul > li.has-sub-nav > a").bind('click', 'touchend', function (e) {
            e.preventDefault();
            $(".main-nav ul > li").find("> ul:visible").slideUp()
            $(".main-nav ul > li").removeClass("active")
            if ($(this).parent().find("> ul:visible").length) {
                $(this).removeClass("active")
                $(this).parent().find("> ul").slideUp()
            } else {
                $(this).addClass("active")
                $(this).parent().find("> ul").slideDown()
            }
        })

         var lastScrollTopPos = 0;

        $('#phone-nav').on('click',function () {


            $('#nav-main').fadeToggle("fast", function() {
                $( "#nav-main" ).toggleClass('animate');
            });
        });

        /*  modal */


        $('.phone-nav').on('click',function (e) {
            e.preventDefault();
            lastScrollTopPos = $(window).scrollTop();
            $(".nav-modal-wrap").fadeIn();
            $("body").addClass("navExpanded");
            setTimeout(function(){
                $( ".nav-modal-wrap" ).addClass('animate');
            },800);
        })
        $(".back-btn").click(function (e) {
            e.preventDefault();
            $(".nav-modal-wrap").fadeOut();
            $("body").removeClass("navExpanded");
            setTimeout(function(){
                $( ".nav-modal-wrap" ).removeClass('animate');
            },800);
        })

        $(".nav-modal-wrap").on('click',function(e){
            e.stopPropagation();
        })

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        var cartList = $('.cart-onorder-item-wrap'),
        cartWrap = $('.cart-main'),
        cartOnorderContent = $('.cart-onorder-content');
        function cartModalOpen(e){
            e.preventDefault();
            $('.cart-wrap').fadeIn(400);
            $("body").addClass("cart-expand");
            freeShippingBarOpen();
            if($(window).width() > 767){
                setTimeout(function(){
                    $("body").addClass("cart-upsell-expand");
                },400)
            } else {
                $("body").addClass("cart-upsell-expand");
            }
            if ($('.cross-sell-carousel').hasClass('slick-initialized')) {
                $('.cross-sell-carousel').slick('unslick');
            }
            $('.cross-sell-carousel').slick({
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 3,
                infinite: true,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '12%',
                        }
                    }
                ]
            });
            setTimeout(function(){
                calculateCartSize();
            },50)
        }
        
        // $('body').on('click','.cart-content-inner',cartModalOpen);

        $(document).on('click','.cart-content-inner',function(e){
            e.preventDefault();
            window.location.href = '/cart';
        })


        $(window).on('load resize orientationchange', calculateCartSize);
        function calculateCartSize(){
            if(cartList.length > 0) {
                if($(window).height() > 500){
                    var sliderHeight = $('.cross-sell-wrap').outerHeight();
                } else {
                    var sliderHeight = 0;
                }
                var scrollTop = $(window).scrollTop(),
                cartListTop = cartList.offset().top,
                cartHeaderH = cartListTop - scrollTop,
                windowH = $(window).height(),
                checkoutH = $('.order-checkout-wrap').outerHeight(),
                cartFormH = windowH - cartHeaderH,
                cartMaxHeight = cartFormH - checkoutH - sliderHeight;
                cartOnorderContent.css('height',cartFormH+'px');

                if($(window).width() > 767){
                    cartMaxHeight = cartFormH - checkoutH;
                    cartList.css({'max-height':cartMaxHeight});
                    $('.modal-inner form.cart').css({'height':cartFormH+'px','padding-bottom':checkoutH+'px','padding-top':'0px'});
                    $('#modal-wrap').css('height',windowH);
                    $('.cross-sell-wrap').css('bottom','0px');
                } else {
                    var sliderH = $('.cross-sell-wrap').outerHeight(),
                    newCheckoutH = checkoutH + sliderH,
                    scrollTop = $(window).scrollTop(),
                    cartListTop = cartList.offset().top,
                    cartMaxHeight = cartFormH - checkoutH - sliderHeight;
                    bagHeaderH = cartListTop - scrollTop;
                    cartList.css({'max-height':cartMaxHeight});
                    $('.modal-inner form').css({'height':windowH,'padding-bottom':newCheckoutH+'px','padding-top':bagHeaderH+'px'});
                    $('.cross-sell-wrap').css('bottom',checkoutH+'px');
                }
            }
        }



        $(".cross-btn, .cart-bg").on('click','',function (e) {
            e.preventDefault();
            if($(window).width() > 767){
                setTimeout(function(){
                    $('.cart-wrap').fadeOut(400);
                    $("body").removeClass("cart-expand"); 
                    freeShippingBarClose();
                },400);
            } else {
                $('.cart-wrap').fadeOut(400);
                $("body").removeClass("cart-expand"); 
                freeShippingBarClose();
            }
            $("body").removeClass("cart-upsell-expand");
        })

        $(".cart-wrap").on('click',function(e){
            e.stopPropagation();
        })
       
        // End venue-carousel function 

        if ($("select.stylled-select").length) {
            $("select.stylled-select").selectric();

        }
        if($('.product-form__variants').length){
          $('.product-form__variants').on('change', function(){
            var data = $(this).find(':selected').data('inventory');
            $(this).parents('form').find('.quantity').attr('max',data);
            if(data < 20) {
                $('p.stock-count').addClass('stock-count-visible');
                $('p.stock-count > span').html(data);
            } else {
                $('p.stock-count').removeClass('stock-count-visible');
            }
          })
        }
        


        
        
        $('.hover').mouseenter(function(){
            $(this).addClass('hoverd');
        });

        $('.hover').mouseleave(function(){
            $(this).removeClass('hoverd');
        })
        
        // CART BUTTON ANIMATION
        $('.add-to-cart-trigger').on('click', function(e){
            var $this = $(this);
            $this.addClass('loading');
            setTimeout(function(){
                $this.removeClass('loading');
                cartModalOpen(e);
             }, 2000);
        })
        
        /*tab1*/
        var mdquery = window.matchMedia("(max-width: 767px)");
        if (mdquery.matches) {
            if ($("select.mobiselect").length) {
                $("select.mobiselect").selectric();
            }
            var tslitem = $( "#" + $("select.mobiselect option:selected").val());
            tslitem.addClass("active");
            $("select.mobiselect").on("change", function() {
                var tchitem = $("#" + $("select.mobiselect option:selected").val());
                var tchheight = tchitem.height() + 100;
                $(".tab-item-wrap").css({ height: tchitem + "px" });
                $(".tab-item-wrap > div").removeClass("item-active");
                tchitem.addClass("item-active");
            });
        }

        // Cleaned up and improved tab/slider logic for desktop and mobile

        function initTabSliders() {
            // Destroy any existing slick instances to avoid duplicates
            $('.tab-item-wrap .tab-slider-wrap').each(function() {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('unslick');
                }
            });

            var isDesktop = window.matchMedia("(min-width: 767px)").matches;
            var isMobile = window.matchMedia("(max-width: 767px)").matches;

            $('.tab-wrap').each(function() {
                var $tabWrap = $(this);
                var $tabItems = $tabWrap.find('.tab-item-wrap > .tab-item');
                var $sliderWraps = $tabWrap.find('.tab-item-wrap .tab-slider-wrap');

                // Desktop
                //if (isDesktop) {
                    // Initialize slick for each slider
                    $sliderWraps.each(function() {
                        $(this).slick({
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            arrows: true,
                            fade: false,
                            swipe: true,
                            swipeToSlide: true,
                            dots: true,
                            lazyLoad: 'progressive',
                            responsive: [
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                        autoplay: false,
                                        speed: 700,
                                        arrows: true,
                                        loop: false,
                                        dots: true,
                                        centerMode: true,
                                        centerPadding: "45px"
                                    }
                                },
                                {
                                    breakpoint: 450,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        autoplay: false,
                                        speed: 700,
                                        arrows: true,
                                        loop: false,
                                        dots: true,
                                        centerMode: true,
                                        centerPadding: "45px"
                                    }
                                }
                            ]
                        });
                    });

                    // Set first tab active
                    var $tabTriggers = $tabWrap.find("#tab-triger-inner ul > li");
                    $tabTriggers.removeClass("tab-active").eq(0).addClass("tab-active");
                    $tabItems.removeClass("item-active").eq(0).addClass("item-active");

                    // Tab click event
                    $tabTriggers.each(function(i) {
                        $(this).off('click.tab').on('click.tab', function(e) {
                            e.preventDefault();
                            if ($(this).hasClass("tab-active")) return false;
                            $tabTriggers.removeClass("tab-active");
                            $(this).addClass("tab-active");
                            $tabItems.removeClass("item-active").eq(i).addClass("item-active");
                        });
                    });
                //}

                // Mobile
                /*
                if (isMobile) {
                    // Set first tab active
                    var $tabLinks = $tabWrap.find(".tab-triger-inner > ul > li > a");
                    $tabLinks.removeClass("active").eq(0).addClass("active");
                    $tabItems.removeClass("item-active").eq(0).addClass("item-active");

                    // Tab click event
                    $tabLinks.each(function(i) {
                        $(this).off('click.tab').on('click.tab', function(e) {
                            e.preventDefault();
                            if ($(this).hasClass("active")) return false;
                            $tabLinks.removeClass("active");
                            $(this).addClass("active");
                            $tabItems.removeClass("item-active").eq(i).addClass("item-active");
                        });
                    });

                    // Initialize slick for each slider
                    $sliderWraps.each(function() {
                        $(this).slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                            fade: false,
                            dots: true,
                            draggable: true,
                            swipeToSlide: true,
                            lazyLoad: 'progressive',
                            responsive: [
                                {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                        autoplay: false,
                                        speed: 700,
                                        arrows: false,
                                        loop: false,
                                        dots: true,
                                        centerMode: true,
                                        centerPadding: "45px"
                                    }
                                },
                                {
                                    breakpoint: 450,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        autoplay: false,
                                        speed: 700,
                                        arrows: false,
                                        loop: false,
                                        dots: true,
                                        centerMode: true,
                                        centerPadding: "45px"
                                    }
                                }
                            ]
                        });
                    });
                }
                    */
            });
        }

        $(document).ready(function(){

var window_width = $(window).width();
  var $desc = $('.product-overview-description');
  var $btn  = $('.product-description-toggle');
    if ($desc.length) {

        // Get actual height vs clamped height
        var fullHeight;

        $desc.addClass('is-expanded');
        fullHeight = $desc.outerHeight();
        $desc.removeClass('is-expanded');

        var clampedHeight = $desc.outerHeight();

        if (fullHeight > clampedHeight) {
        $btn.show();
        }

        $btn.on('click', function(){
        $desc.toggleClass('is-expanded');

        if ($desc.hasClass('is-expanded')) {
            $(this).text('Read less');
        } else {
            $(this).text('Read more');
        }
        });

    }

//   if(window_width <=767){
//     if ($desc.length) {

//         // Get actual height vs clamped height
//         var fullHeight;

//         $desc.addClass('is-expanded');
//         fullHeight = $desc.outerHeight();
//         $desc.removeClass('is-expanded');

//         var clampedHeight = $desc.outerHeight();

//         if (fullHeight > clampedHeight) {
//         $btn.show();
//         }

//         $btn.on('click', function(){
//         $desc.toggleClass('is-expanded');

//         if ($desc.hasClass('is-expanded')) {
//             $(this).text('Read less');
//         } else {
//             $(this).text('Read more');
//         }
//         });

//     }
//   }

  

});

        // Initial run
        initTabSliders();

        // Re-initialize on resize, but debounce for performance
        var resizeTimeout;
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                initTabSliders();
            }, 200);
        });

        /*tab2*/
        
            $('.tab-item-wrap-2 .tab-slider-wrap').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: true,
                swipeToSlide: true,
                lazyLoad: 'progressive',
                responsive: [


                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            autoplay: false,
                            speed: 700,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            arrows: false,
                            centerMode: true,
                            centerPadding: "45px",
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            autoplay: false,
                            speed: 700,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            arrows: false,
                            centerMode: true,
                            centerPadding: "45px",
                        }
                    },

                    
                ]
            });
            $(window).on('resize', function () {
                $('#tab-item-wrap-2 .tab-slider-wrap').slick('resize');
            });

            $("#tab-triger-inner-2 ul > li").removeClass("tab-actived")
            $("#tab-triger-inner-2 ul > li").eq(0).addClass("tab-actived")
            $("#tab-item-wrap-2 > div.tab-item").eq(0).addClass("item-actived")


            $("#tab-triger-inner-2 ul > li").each(function (i) {
                $(this).click(function (e) {

                    if ($(this).hasClass("tab-actived")) return false
                    else {
                        $("#tab-triger-inner-2 ul > li").removeClass("tab-actived")
                        $(this).addClass("tab-actived")
                        $("#tab-item-wrap-2 > div.tab-item").removeClass("item-actived")
                        $("#tab-item-wrap-2 > div.tab-item").eq(i).addClass("item-actived")
                    }
                })
            });
        /*        
        const container = document.querySelector('.awards-item-wrap');
        const itemsWrapper = document.querySelector('.awards-row-wrap');

        // Preload images
        const preloadImages = () => {
            return new Promise((resolve, reject) => {
                imagesLoaded(document.querySelectorAll('img'), resolve);
            });
        };
        // And then..

        preloadImages().then(() => {
            // Remove the loader
            document.body.classList.remove('loading');
            const effect = new StretchEffect(container, itemsWrapper)
        });
        */



        if($('#assoc-product-slider').length > 0){
            $('#assoc-product-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                dots: true,
                swipeToSlide: true,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            autoplay: false,
                            speed: 700,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            centerMode: true,
                            centerPadding: "45px",
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            autoplay: false,
                            speed: 700,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            centerMode: true,
                            centerPadding: "45px",
                        }
                    },

                    
                ]
            });
        }
        $(window).on('resize', function () {
            $('#assoc-product-slider').slick('resize');
        });

        /* Product Page */
        
        if ($(".product-content").length) {
            $("body").addClass("product-page")
        }

        $('.insta__images').slick({
            slidesToShow: 4,
            slidesToScroll: 2,
            arrows: false,
            dots: false,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });


          var myWindowWidth = $(window).width();
          if(myWindowWidth <=767){
            $('.featured-product__items').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
              });
          }

        /* Product Page */


        /* Blog / cocktail page */
        if($('.blog-slider').length > 0) {
            $('.blog-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: true,
                infinite: false,
                swipeToSlide: true,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            arrows: false,

                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            autoplay: false,
                            speed: 700,
                            controlNav: false,
                            directionNav: false,
                            arrows: false,
                            loop: false,
                            dots: true,
                            arrows: false,

                        }
                    }
                ]
            });
            $(window).on('resize', function () {
                $('.blog-slider').slick('resize');
            });
        }

            /* End blog / cocktail page */



        if ($(".shop-main-content").length) {
            $("body").addClass("shop-main-page")
        }


        $(window).on('load resize orientationchange', function(){
            if ($(window).width() < 768) {
                if($('#product-gallery-slider:not(.slick-initialized)').length > 0) {
                    $('#product-gallery-slider').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: false,
                        dots: true,
                        centerMode: true,
                        centerPadding: '65px',
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: "unslick"
                            },
                        ]
                    })
                }
                if($('.product-gallery-slider:not(.slick-initialized)').length > 0) {
                    $('.product-gallery-slider').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: false,
                        dots: true,
                        centerMode: true,
                        centerPadding: '65px',
                        responsive: [
                            {
                                breakpoint: 450,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    autoplay: false,
                                    speed: 700,
                                    controlNav: false,
                                    directionNav: false,
                                    arrows: false,
                                    loop: false,
                                    dots: true,
                                    centerMode: true,
                                    centerPadding: "45px",
                                }
                            },
                        ]
                    });
                }
                if($('#assoc-product-mobi-slider:not(.slick-initialized)').length > 0) {
                    $('#assoc-product-mobi-slider').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: false,
                        dots: true,
                        centerMode: true,
                        centerPadding: '65px',
                        responsive: [
                            {
                                breakpoint: 450,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    autoplay: false,
                                    speed: 700,
                                    controlNav: false,
                                    directionNav: false,
                                    arrows: false,
                                    loop: false,
                                    dots: true,
                                    centerMode: true,
                                    centerPadding: "45px",
                                }
                            },
                        ]
                    })
                }
            };
            $(window).on('resize', function () {
                if ($(window).width() < 768) {
                    if($('.product-gallery-slider.slick-initialized').length > 0) {
                        $('.product-gallery-slider.slick-initialized').slick('resize');
                    }
                    if($('#product-gallery-slider').length > 0) {
                        $('#product-gallery-slider').slick('resize');
                    }
                    if($('#assoc-product-mobi-slider').length > 0) {
                        $('#assoc-product-mobi-slider').slick('resize');
                    }
                } else {
                    if($('.product-gallery-slider.slick-initialized').length > 0) {
                        $('.product-gallery-slider.slick-initialized').slick('unslick');
                    }
                    if($('#product-gallery-slider.slick-initialized').length > 0) {
                        $('#product-gallery-slider.slick-initialized').slick('unslick');
                    }
                    if($('#assoc-product-mobi-slider.slick-initialized').length > 0) {
                        $('#assoc-product-mobi-slider.slick-initialized').slick('unslick');
                    }
                }
            });
        })
        // Accordion Function
        
        $(".product-accordion-item").each(function(){
            var $this = $(this);
            $this.find(" > span").on("click touch", function(){
                $(".product-accordion-item").removeClass("product-accordion-active")
                $(".product-accordion-content").slideUp();
                if($this.find(".product-accordion-content:visible").length){
                    $(".product-accordion-item").removeClass("product-accordion-active")
                    $(".product-accordion-content").slideUp();
                }
                else{
                    $this.addClass("product-accordion-active")
                    $(".product-accordion-content").slideUp();
                    $this.find(" > .product-accordion-content").slideDown();
                }
            })
        })


        /* Product Page */
        if ($('.product-overview-slider').length > 0 && $('.product-single__thumbnails-item').length > 1) {
            $('.product-overview-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: false,
            });
        } else if($('.product-overview-slider').length > 0) {
          $('.product-overview-slider').addClass('single-image-preview'); 
        };

        $('.plus').on('click',function () {
            var $this = $(this).parent().find('input[type="number"]');
            var max = parseInt($this.attr('max'));
            if($this.val() < max) {
                $this.val(Number($this.val()) + 1);
            }
            
        })

        $('.minus').on('click',function () {
            var $this = $(this).parent().find('input[type="number"]');
            var amount = Number($this.val());
            if (amount > 1) {
                $this.val(amount - 1);
            }
        });

        if($('.product-overview-description').length > 0) {

            var description = $('.product-overview-description'),
            descriptionH = $('.product-overview-description').outerHeight(),
            windowH70 = $(window).height()* 0.7;
            $(window).on('resize orientationchange', function(){
                var descriptionH = $('.product-overview-description').outerHeight(),
                windowH70 = $(window).height()* 0.7;
            })
          

            if(descriptionH > windowH70) {
                description.css('max-height',windowH70);
                $('.product-overview-content').addClass('content-trigger content-closed');
            }

            $('.more-info').on('click',function(){
                if($(this).hasClass('more-info-active')) {
                    $(this).removeClass('more-info-active');
                    description.css('max-height',windowH70);
                    $('.product-overview-content').addClass('content-closed');
                    $('.product-overview-content').removeClass('content-open'); 
                } else {
                    $(this).addClass('more-info-active');
                    description.css('max-height',descriptionH);
                    $('.product-overview-content').removeClass('content-closed');
                    $('.product-overview-content').addClass('content-open'); 
                }
                
            });
        }


        $(".btn-new-anchor").click(function(e) {
            e.preventDefault();
            var destination = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(destination).offset().top
            }, 1000);
        });

        
        // MAGENETIC PLAY BUTTON
        // class HoverButton {
        //   constructor(el) {
        //     this.el = el;
        //     this.hover = false;
        //     this.calculatePosition();
        //     this.attachEventsListener();
        //   }

        //   attachEventsListener() {
        //     window.addEventListener('mousemove', e => this.onMouseMove(e));
        //     window.addEventListener('resize', e => this.calculatePosition(e));
        //     window.addEventListener('scroll', e => this.calculatePosition(e));
        //   }

        //   calculatePosition() {
        //     TweenMax.set(this.el, {
        //       x: 0,
        //       y: 0,
        //       scale: 1 });

        //     const box = this.el.getBoundingClientRect();
        //     this.x = box.left + box.width * 0.5;
        //     this.y = box.top + box.height * 0.5;
        //     this.width = box.width;
        //     this.height = box.height;
        //   }

        //   onMouseMove(e) {
        //     let hover = false;
        //     let hoverArea = this.hover ? 0.7 : 0.5;
        //     let x = e.clientX - this.x;
        //     let y = e.clientY - this.y;
        //     let distance = Math.sqrt(x * x + y * y);
        //     if (distance < this.width * hoverArea) {
        //       hover = true;
        //       if (!this.hover) {
        //         this.hover = true;
        //       }
        //       this.onHover(e.clientX, e.clientY);
        //     }

        //     if (!hover && this.hover) {
        //       this.onLeave();
        //       this.hover = false;
        //     }
        //   }

        //   onHover(x, y) {
        //     TweenMax.to(this.el, 0.4, {
        //       x: (x - this.x) * 0.4,
        //       y: (y - this.y) * 0.4,
        //       scale: 1.15,
        //       ease: Power2.easeOut });

        //     this.el.style.zIndex = 10;
        //   }
        //   onLeave() {
        //     TweenMax.to(this.el, 0.7, {
        //       x: 0,
        //       y: 0,
        //       scale: 1,
        //       ease: Elastic.easeOut.config(1.2, 0.4) });

        //     this.el.style.zIndex = 1;
        //   }
        // }

        // $(window).on('load resize scroll',function(){
        //     if($(window).width() > 767) {
        //         if($('.play-video-btn-wrap').length) {
        //            const btn1 = document.querySelector('.play-video-btn-wrap');
        //             new HoverButton(btn1);
        //         }
                
        //     }
        // }) 
        if($('.play-video-btn-wrap').length) {
            // $('.hero-btn-trigger').on('click', function(e){
            //     e.preventDefault();
            //     $('.button-modal-wrap').slideToggle();
            // })
        }
        // END MAGENETIC PLAY BUTTON

        $('.shop-whisky-wrapper').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            loop:false,
            speed: 700,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });


    })// End ready function.
   
    function freeShippingBarOpen() {
        if($('.free-shipping-bar-wrapper').length > 0){
            var progress = $('.free-shipping-bar-wrapper').data('progress');
            $('.free-shipping-bar-inner').css('width',progress+'%');
        }
    }
    function freeShippingBarClose() {
        if($('.free-shipping-bar-wrapper').length > 0){
            $('.free-shipping-bar-inner').css('width','0%');
        }
    }

    $('.cross-sell-carousel').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        infinite: true,
        dots: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 767,
                 settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '12%',
                    }
            }
        ]
    });
    
    function setClickHandler(id, fn) {
        if($('#'+id).length > 0) {
            document.getElementById(id).onclick = fn
        }
    }

    setClickHandler('video_container', function(e) {
        var className = e.target.className
        if (~className.indexOf('htmlvid')) {

            BigPicture({
                el: e.target,
                vidSrc: e.target.getAttribute('vidSrc'),
            })
        }
    })
    $('.checkout-btn').on('click', function(e) {
    
      if ($('#accept-terms').prop('checked') == false){
       e.preventDefault();
       $('.alert-message').slideDown();
       setTimeout(function(){
        $('.alert-message').slideUp();
       },3000);
      }
    });
})(jQuery)

